import { ButtonGoBack } from '@/components';
import React from 'react';
import { Icon, Image, Text } from 'vkit/lib/components';
import { Grid, Row } from 'vkit/lib/context';

export interface HeaderProps {
  title?: string;
  description?: string;
  icon?: string;
  iconSrc?: string;
  hasGoBackAction?: boolean;
  children?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({
  title,
  description,
  icon,
  iconSrc,
  hasGoBackAction,
  children,
}) => {
  return (
    <Row style={{ padding: 0 }}>
      <Grid alignContent='justify' alignItems='center'>
        <Grid column gap={4} stretch>
          <Grid gap={4}>
            {icon && <Icon key={icon} name={icon} color='colorDefault' />}
            {iconSrc && <Image key={iconSrc} alt={title || ''} src={iconSrc} size='minor' />}
            {title && <Text color='colorDefault' value={title || ''} title />}
          </Grid>

          {description && <Text value={description || ''} size='medium' />}
        </Grid>

        <Grid gap={16}>
          {hasGoBackAction && (
            <Grid alignContent='right'>
              <ButtonGoBack />
            </Grid>
          )}

          {children}
        </Grid>
      </Grid>
    </Row>
  );
};

export default Header;
